import { isAxiosError, type AxiosError } from 'axios';
import qs from 'query-string';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { xhr } from '@shared/config';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import type { PaginatedList } from '@shared/types/common';
import { useClient } from '@src/entities/clients';
import type { Event } from '@src/library/models/events';

export const useLoadAcquiredEvets = (id: number, code: string) => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [error, setError] = useState<AxiosError>();
  const [page, setPage] = useState(1);
  const [events, setEvents] = useState<Event[]>([]);

  const { client } = useClient(id);
  const { module } = useModuleByCodeParam();

  const controller = useMemo(() => new AbortController(), []);

  const loadMore = async () => {
    if (!client?.user.id) return;
    setLoading(true);
    try {
      const res = await xhr.get<PaginatedList<Event>>(
        `/api/v1/events/event/by_user/${client?.user.id}/`
        // {
        // 	params: {
        // 		page: page,
        // 		module: module?.id,
        // 	},
        // 	signal: controller.signal,
        // }
      );

      if (!res.data) throw res;

      const { data } = res;
      setEvents((p) => [...p, ...data.results]);

      setHasNextPage(!!data.next);

      if (data.next) setPage((p) => p + 1);
    } catch (error) {
      if (isAxiosError(error)) setError(error);
    }
    setLoading(false);
  };

  const reload = () => {
    const params = qs.parse(search);
    if (params?.onClose === 'reload') {
      setLoading(false);
      setHasNextPage(true);
      setPage(1);
      setEvents([]);
      navigate(pathname);
    }
    return () => {
      controller.abort();
    };
  };

  useEffect(reload, [search]);

  return {
    loading,
    events,
    hasNextPage,
    error,
    loadMore,
  };
};
